// Email validation using regex
export const isValidEmail = (email: string): boolean => {
  if (!email) return false;
  
  // Trim whitespace
  email = email.trim();
  
  // Basic format validation (username@domain.tld)
  const basicRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!basicRegex.test(email)) return false;
  
  // More comprehensive validation
  // - Username can contain letters, numbers, dots, underscores, percent, plus, or hyphens
  // - Domain must have at least one dot and valid TLD characters
  const advancedRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!advancedRegex.test(email)) return false;
  
  // Check for consecutive dots which are not allowed
  if (email.includes('..')) return false;
  
  // Check length constraints
  if (email.length > 254) return false;
  
  const [localPart, domain] = email.split('@');
  if (localPart.length > 64) return false;
  
  return true;
};

// Password validation
export const isValidPassword = (password: string): boolean => {
  // At least 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  return regex.test(password);
};

// Password validation errors
export const getPasswordValidationErrors = (password: string): string[] => {
  const errors: string[] = [];
  
  if (password.length < 8) {
    errors.push('Password must be at least 8 characters long');
  }
  
  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }
  
  if (!/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }
  
  if (!/\d/.test(password)) {
    errors.push('Password must contain at least one number');
  }
  
  if (!/[@$!%*?&]/.test(password)) {
    errors.push('Password must contain at least one special character (@$!%*?&)');
  }
  
  return errors;
};

// URL validation
export const isValidUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
};

// Hex color validation
export const isValidHexColor = (color: string): boolean => {
  const regex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
  return regex.test(color);
};